export default "__VITE_ASSET__BiESJ5m3__"